import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import { SSOPage, ForgotPassword, ResetPassword } from "@/pages/AuthExtras";
import Layout from "@/components/Layout";
import Inbox from "@/pages/Inbox";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import Settings from "@/pages/Settings";
import CustomerChat from "@/pages/CustomerChat";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="sd-app flex items-center justify-center h-screen font-heading font-bold">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/chat" element={<CustomerChat />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/sso" element={<SSOPage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Inbox />} />
            <Route path="/dashboard" element={<AdminOnly><Dashboard /></AdminOnly>} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/settings" element={<AdminOnly><Settings /></AdminOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
